import { MyLiNKQueryKeys } from "constants/my-link-query-keys";
import UserBookmarkRecord from "models/view-models/user-bookmark-record";
import { useQuery } from "react-query";
import { useParams } from "react-router";
import { CollectionUtils } from "utilities/collection-utils";
import { t } from "utilities/localization-utils";
import PublicationService from "utilities/services/publications/publication-service";
import UserBookmarkService, {
    UserBookmarkListQueryParams,
} from "utilities/services/user-bookmarks/user-bookmark-service";
import { ToastManager } from "utilities/toast/toast-manager";
export interface BookmarkQueryResponse {
    bookmarks: UserBookmarkRecord[];
    bookmarksLength: number;
}
export interface UseBookmarksByPublicationQueryOptions
    extends UserBookmarkListQueryParams {}

export default function useBookmarksByPublicationQuery(
    options: UseBookmarksByPublicationQueryOptions
) {
    const { groupId: code } = useParams<{ groupId: string }>();
    const {
        data: bookmarks,
        isLoading,
        refetch: refetchAllBookmarks,
    } = useQuery({
        queryKey: [
            MyLiNKQueryKeys.BookmarksByPublicationCode,
            code,
            options.sortBy,
            options.searchText,
            options.skip,
            options.take,
            options.currentUserOnly,
        ],
        queryFn: async () => await fetchBookmarks(code, options),
        keepPreviousData: true,
    });

    const { data: publication } = useQuery({
        queryKey: [MyLiNKQueryKeys.PublicationDetail, code],
        queryFn: async () => await fetchPublication(code),
    });

    return { bookmarks, isLoading, refetchAllBookmarks, publication };
}

const fetchBookmarks = async (
    code: string,
    options: UserBookmarkListQueryParams
) => {
    try {
        const result = await UserBookmarkService.list({
            code,
            skip: options?.skip,
            take: options?.take,
            searchText: options?.searchText,
            sortBy: options?.sortBy,
        });

        if (result.result?.hasErrors()) {
            throw new Error();
        }
        return {
            bookmarks: result.resultObjects,
            bookmarksLength: result.rowCount,
        };
    } catch (err) {
        ToastManager.error(
            t("errors-actionResource", {
                action: t("loading"),
                resource: t("bookmark_plural"),
            })
        );
    }
};

const fetchPublication = async (code: string) => {
    try {
        const result = await PublicationService.list({
            code,
        });

        if (result.result?.hasErrors()) {
            throw new Error();
        }
        return CollectionUtils.first(result.resultObjects); // Is there a better way to do this?
    } catch (err) {
        ToastManager.error(
            t("errors-actionResource", {
                action: t("loading"),
                resource: t("publication"),
            })
        );
    }
};
